import { api } from '@/services'

export const details = (body) => {
  return api.post('web/realty/details', body)
}

export const list = (params) => {
  return api.get('/web/realty/list', { params })
}

export const realty = (realtyId) => {
  return api.get(`/web/realty/show/${realtyId}`)
}

export const save = (realty) => {
  return api.post('/web/realty/create', realty)
}

export const update = (realty) => {
  return api.post(`/web/realty/update/${realty.id}`, realty)
}

export const remove = (realtyId) => {
  return api.delete(`web/realty/delete/${realtyId}`)
}

export const quickUpdate = (realtyDetails) => {
  return api.post('/web/realty/quickUpdate', realtyDetails)
}

export const vistaOptions = (params) => {
  return api.get('/web/realty/vistaOptions', { params })
}

export function addPhotos(data){
  let url = `/web/realty/addPhotos`
  return api.post(url, data)
}

export function deletePhotos(data){
  let url = `/web/realty/deletePhotos`
  return api.post(url, data)
}

export function addVideos(data){
  let url = `/web/realty/addVideos`
  return api.post(url, data)
}

export function deleteVideos(data){
  let url = `/web/realty/deleteVideos`
  return api.post(url, data)
}

export function getRealtyVideos(realtyId) {
  let url = `/web/realty/${realtyId}/videos`
  return api.get(url)
}

export function getRealtyPhotos(realtyId) {
  let url = `/web/realty/${realtyId}/photos`
  return api.get(url)
}

// legado
export function findAll (token, params) {
  const options = {
    method: 'GET',
    url: '/web/realty/list',
    params: params,
    headers: {
      Authorization: `${token}`,
    },
  }
  return api(options)
}
